export enum UserRole {
    ADMIN = 'ADMIN',
    QM_RESPONSIBLE = 'QM_RESPONSIBLE',
    SPORTCAST = 'SPORTCAST',
    PM_INTERNAL = 'PM_INTERNAL',
    PM_EXTERNAL = 'PM_EXTERNAL',
    DIRECTOR = 'DIRECTOR',
    DL = 'DL',
    PARTNER = 'PARTNER',
    EMPTY_USER_MASK = 'EMPTY_USER_MASK'
}

export enum InternalUserRole {
    SPORTCAST = UserRole.SPORTCAST,
    PM_INTERNAL = UserRole.PM_INTERNAL
}

export enum ExternalUserRole {
    PM_EXTERNAL = UserRole.PM_EXTERNAL,
    PARTNER = UserRole.PARTNER,
    DIRECTOR = UserRole.DIRECTOR,
    DL = UserRole.DL
}

export enum ExternalCoordinatorRole {
    DL = UserRole.DL,
    PARTNER = UserRole.PARTNER,
}